export default "__VITE_PUBLIC_ASSET__0dc8f6de__"